import React from 'react';
import { TextVariant } from '@naf/text';
import RelatedArticleList from '@components/related-articles/RelatedArticleList';
import { ArticleBlockContentGridCol } from '../components/ArticleBlockContentGridCol/ArticleBlockContentGridCol';
import { BlockContentContext } from '../../BlockContent.utils';
import * as S from '../components/ArticleListSerializer/ArticleListSerializer.styles';
import { Props } from '../components/ArticleListSerializer/ArticleListSerializer';

const ArticleListSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: Props) => (
      <ArticleBlockContentGridCol>
        {value.title && (
          <S.StyledText variant={TextVariant.Tag} tag="p">
            {value.title}
          </S.StyledText>
        )}
        <S.StyledRelatedArticleList relatedContent={value.articleList} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: Props) => <RelatedArticleList relatedContent={value.articleList} />;
};

export default ArticleListSerializer;
